import { defaultIconSize, Icons } from '../Icons';

export enum SampleLifecycle {
  Nothing = 1,
  SampleBeingPreparedAtSupplier = 2,
  SampleBeingPreparedReadySampleDatePassed = 3,
  SampleReceivedFromSupplier = 4,

  SampleUnhandled = 8,
  SampleLost = 12,

  SampleInBrandTransportRequestAwaitingShipment = 21,
  SampleInBrandTransportRequestAwaitingDispatch = 22,
  SampleInBrandTransportRequestDispatched = 23,
  SampleReceivedAtBrand = 24,

  SampleInInternalTransportRequestAwaitingShipment = 31,
  SampleInInternalTransportRequestAwaitingDispatch = 32,
  SampleInInternalTransportRequestDispatched = 33,

  SampleRejected = 97,
  SampleCancelled = 98,
  SampleAccepted = 99,
  SampleOnHold = 100,
}

export enum SampleAction {
  RestartSampling = 1,
  InitiateSampling = 2,
  None = 3,
  SendToInternalOrHandlePa = 5,
  ReadySampleDatePassedSetNew = 6,
  MarkSampleReceivedFromSupplier = 7,
  SendSampleOrHandlePa = 8,
  UnpackShipment = 9,
  SentToCustomerHandlePa = 10,
  UpdateTransportRequestWithoutShipment = 11,
}

export enum SampleLifecycleGroup {
  UnderwayFromSupplier = 4,
  ReceivedFromSupplier = 2,
  UnhandledSamples = 1,
  ReceivedAtBrand = 3,
  InBrandTransport = 98,
  InInternalTransport = 99,
  HandledSamples = 100,
}

interface GroupConfig {
  icon?: React.ReactElement;
}

export const sampleLifecycleGroupConfig: Record<
  keyof typeof SampleLifecycleGroup,
  GroupConfig
> = {
  UnderwayFromSupplier: {
    icon: <Icons.Truck boxSize={defaultIconSize} />,
  },
  ReceivedFromSupplier: {
    icon: <Icons.GiftOpen boxSize={defaultIconSize} />,
  },
  InInternalTransport: {
    icon: <Icons.TruckDelivery boxSize={defaultIconSize} />,
  },
  UnhandledSamples: {
    icon: <Icons.ArrowCollapseRight boxSize={defaultIconSize} />,
  },
  InBrandTransport: {
    icon: <Icons.TruckFast boxSize={defaultIconSize} />,
  },
  ReceivedAtBrand: {
    icon: <Icons.ArrowExpandDown boxSize={defaultIconSize} />,
  },
  HandledSamples: {
    icon: <Icons.Eye boxSize={defaultIconSize} />,
  },
};

export const lifecycleToGroup: Record<SampleLifecycle, SampleLifecycleGroup> = {
  [SampleLifecycle.Nothing]: SampleLifecycleGroup.UnhandledSamples,
  [SampleLifecycle.SampleBeingPreparedAtSupplier]:
    SampleLifecycleGroup.UnderwayFromSupplier,
  [SampleLifecycle.SampleBeingPreparedReadySampleDatePassed]:
    SampleLifecycleGroup.UnderwayFromSupplier,
  [SampleLifecycle.SampleReceivedFromSupplier]:
    SampleLifecycleGroup.ReceivedFromSupplier,
  [SampleLifecycle.SampleLost]: SampleLifecycleGroup.UnhandledSamples,
  [SampleLifecycle.SampleUnhandled]: SampleLifecycleGroup.UnhandledSamples,
  [SampleLifecycle.SampleReceivedAtBrand]: SampleLifecycleGroup.ReceivedAtBrand,
  [SampleLifecycle.SampleOnHold]: SampleLifecycleGroup.ReceivedAtBrand,
  [SampleLifecycle.SampleInBrandTransportRequestAwaitingShipment]:
    SampleLifecycleGroup.InBrandTransport,
  [SampleLifecycle.SampleInBrandTransportRequestAwaitingDispatch]:
    SampleLifecycleGroup.InBrandTransport,
  [SampleLifecycle.SampleInBrandTransportRequestDispatched]:
    SampleLifecycleGroup.InBrandTransport,
  [SampleLifecycle.SampleInInternalTransportRequestAwaitingShipment]:
    SampleLifecycleGroup.InInternalTransport,
  [SampleLifecycle.SampleInInternalTransportRequestAwaitingDispatch]:
    SampleLifecycleGroup.InInternalTransport,
  [SampleLifecycle.SampleInInternalTransportRequestDispatched]:
    SampleLifecycleGroup.InInternalTransport,
  [SampleLifecycle.SampleAccepted]: SampleLifecycleGroup.HandledSamples,
  [SampleLifecycle.SampleRejected]: SampleLifecycleGroup.HandledSamples,
  [SampleLifecycle.SampleCancelled]: SampleLifecycleGroup.HandledSamples,
};
